import React from 'react';

import { registerDecoration } from 'core/forms';

import { Typo } from 'uikit/content';

import styles from '../styles/formDecorationSectionHeading.module.scss';

const FormDecorationSectionHeading = ({ schema: { text } }) => (
  <Typo className={styles.title} element="h2" variant="d01">
    {text}
  </Typo>
);

registerDecoration('SectionHeading', React.memo(FormDecorationSectionHeading));

export default FormDecorationSectionHeading;
